var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 9.37917L21.7507 8.83849C22.6465 7.94267 24.099 7.94267 24.9948 8.83849C25.8907 9.73432 25.8907 11.1867 24.9948 12.0825L24.4541 12.6233M21.21 9.37917C21.21 9.37917 21.2777 10.5281 22.2914 11.5419C23.3052 12.5556 24.4541 12.6233 24.4541 12.6233M21.21 9.37917L16.2393 14.3498C15.9026 14.6865 15.7342 14.8549 15.5895 15.0405C15.4188 15.2595 15.2724 15.4964 15.1529 15.747C15.0516 15.9596 14.9763 16.1854 14.8258 16.6371L14.3437 18.0833L14.1877 18.5511M24.4541 12.6233L19.4834 17.594C19.1467 17.9307 18.9784 18.099 18.7928 18.2438C18.5738 18.4145 18.3368 18.5609 18.0862 18.6804C17.8737 18.7817 17.6479 18.857 17.1962 19.0075L15.75 19.4896L15.2822 19.6456M14.1877 18.5511L14.0317 19.0191C13.9576 19.2413 14.0155 19.4864 14.1812 19.6521C14.3468 19.8178 14.592 19.8756 14.8142 19.8016L15.2822 19.6456M14.1877 18.5511L15.2822 19.6456",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 15.1666H12.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 10.5H16.9167",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 19.8334H11.0833",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1331 3.70021C21.7664 2.33337 19.5664 2.33337 15.1667 2.33337H12.8333C8.43355 2.33337 6.23367 2.33337 4.86683 3.70021C3.5 5.06705 3.5 7.26693 3.5 11.6667V16.3334C3.5 20.7331 3.5 22.9331 4.86683 24.2998C6.23367 25.6667 8.43355 25.6667 12.8333 25.6667H15.1667C19.5664 25.6667 21.7664 25.6667 23.1331 24.2998C24.2334 23.1996 24.448 21.5596 24.4898 18.6667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignDocument);
export default __webpack_public_path__ + "static/media/sign-document.9efdce72610bff8eb50142fab9f780c9.svg";
export { ForwardRef as ReactComponent };